
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/corporate",
      function () {
        return require("private-next-pages/programs/corporate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/corporate"])
      });
    }
  